<template>
  <div class="crunchieMain">
    <Pager class="pager" />
    <Pager class="pager2" :mode="'P'" :form="mainData['form']" :data="mainData" @quickPrintCancel="quickPrintCancel"/>
  </div>
</template>

<script>
  import Pager from '@/components/reportDesigner/Pager.vue';
  /* eslint-disable */
  
  
  export default {
    name: 'crunchie',
    components: {
        Pager
    },
    props: {
      
    },
    data() { 
      return {
        mainData: {
          // 'form': 'TestSave_ABLogistics.json',
          'form': 'ROT_BL',
        },
      }
    },
    mounted() {
      
    },
    beforeDestroy() {
      
    },
    methods: {
      quickPrintCancel: async function() {
        console.log('Quick Print Cancel');
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .crunchieMain {
    width: auto;
    height: 100%;
    padding: 20px 0 20px 40px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #EEEF;
    border: solid 1px #f000;
    overflow: none;
  }

  .pager {
    width: 1000px;
    margin: 0 5px;
    box-shadow: 0 0 8px #0004;
  }

  .pager2 {
    width: 400px;
    margin: 0 5px;
    box-shadow: 0 0 8px #0004;
  }

</style>